import graphql__6211cee1058c07b99831 from "./__generated__/MapElementsVectorGrid_map.graphql.js";import { useCallback, useState } from "react";
import { graphql, useFragment } from "react-relay";

import VectorGrid from "../VectorGrid";
import { useFormatVectorTileLayerStyles } from "./MapElementsVectorGridTileLayerStyles";
import MapElementsVectorGridTooltip from "./MapElementsVectorGridTooltip";
import MapElementsVectorGridClickHandler from "./MapElementsVectorGridClickHandler";
import MapClusterizedPointMarkers from "./MapClusterizedPointMarkers";
import { useVectorGridHover } from "./useVectorGridHover";
import { useIsNonDesktop } from "../../Utils/ResponsiveQueries";

const MapElementsVectorGrid = props => {
  // Make a standalone GraphQL fragment here
  const map = useFragment(MapElementsVectorGrid_map, props.map);
  const { onElementClick } = props;

  const { hasElements, vectorTileUrl } = map;

  const isNonDesktop = useIsNonDesktop();

  const [clickedMapElementGeometry, setClickedMapElementGeometry] = useState();
  const [tappedTooltip, setTappedTooltip] = useState(null);

  const handleMapElementClicked = useCallback(
    (event, mapElementGeometry) => {
      const { id: mapElementGeometryId } = mapElementGeometry;

      if (clickedMapElementGeometry?.id === mapElementGeometryId) return;

      if (onElementClick) onElementClick(event, mapElementGeometry);

      setClickedMapElementGeometry(mapElementGeometry);
    },
    [clickedMapElementGeometry, onElementClick]
  );

  const handleVectorGridClicked = useCallback(
    e => {
      const mapElementGeometry = e.layer.properties;
      const {
        id: mapElementGeometryId,
        hasInformationWindow,
        hasTooltip
      } = mapElementGeometry;

      // On small screens the information window has priority because showing both
      // overlays at once hides too much of the map. The tooltip is used as a fallback.
      if (isNonDesktop) {
        const nextTappedTooltip =
          hasTooltip && !hasInformationWindow
            ? { mapElementGeometryId, position: e.latlng }
            : null;

        setTappedTooltip(nextTappedTooltip);
      }

      handleMapElementClicked(e, mapElementGeometry);
    },
    [handleMapElementClicked, isNonDesktop]
  );

  const handleTappedTooltipDismissed = useCallback(() => setTappedTooltip(null), []);

  const {
    hoveredMapElementGeometryId,
    handleVectorGridHovered,
    handleVectorGridHoveredOut
  } = useVectorGridHover();

  // Use the formatVectorTileLayerStyles function to get the vector tile layer styles
  const vectorTileLayerStyles = useFormatVectorTileLayerStyles({ map });

  // Don't display the vector grid if there are no elements to load, as it would use
  // unnecessary resources.
  if (!hasElements) return null;

  return (
    <>
      <MapClusterizedPointMarkers map={map} onPointClick={handleMapElementClicked} />

      <MapElementsVectorGridTooltip
        hoveredMapElementGeometryId={hoveredMapElementGeometryId}
        onTappedTooltipDismissed={handleTappedTooltipDismissed}
        tappedTooltip={tappedTooltip}
      />

      {clickedMapElementGeometry?.id && (
        <MapElementsVectorGridClickHandler
          key={clickedMapElementGeometry.id}
          mapElementGeometry={clickedMapElementGeometry}
          setClickedMapElementGeometry={setClickedMapElementGeometry}
        />
      )}

      <VectorGrid
        url={vectorTileUrl}
        type="protobuf"
        idField="id"
        subdomains={[]}
        vectorTileLayerStyles={vectorTileLayerStyles}
        interactive
        getFeatureId={feature => feature.id}
        onClick={handleVectorGridClicked}
        onMouseover={handleVectorGridHovered}
        onMouseout={handleVectorGridHoveredOut}
      />
    </>
  );
};

const MapElementsVectorGrid_map = graphql__6211cee1058c07b99831;

export default MapElementsVectorGrid;
